var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "25 25 50 50"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 20,
  fill: "none",
  className: "path"
})));
export default SvgCircle;